import { Box, Container, Typography, Grid, Stack, useMediaQuery, useTheme } from '@mui/material';
import { psiTokens } from '../theme/psiTheme';
import PageHeader from '../components/PageHeader';
import { usePageMeta } from '../hooks/usePageMeta';

const credentials = [
  'Master Black Belt · Six Sigma',
  'Lean Expert',
  'CI & Problem Solving',
  '+20 Years',
  'EN / ES',
];

export default function About() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  usePageMeta(
    'About',
    "Meet Fidel Gutiérrez Sánchez, PSI's founder and Master Black Belt in Six Sigma, with over 20 years of experience in industrial training and consulting."
  );

  return (
    <Box sx={{ backgroundColor: psiTokens.background.primary }}>
      <PageHeader
        eyebrow="Who Is Behind PSI"
        title="Fidel Gutiérrez Sánchez"
        subtitle="Founder · Lead Consultant · Master Black Belt in Six Sigma"
      />

      <Container maxWidth="xl" sx={{ py: isMobile ? 6 : 8 }}>
        <Box
          sx={{
            width: '40px',
            height: '3px',
            background: `linear-gradient(90deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light})`,
            borderRadius: '2px',
            mb: 4,
          }}
        />

        <Grid container spacing={6} alignItems="flex-start">
          <Grid item xs={12} md={7}>
            <Typography sx={{ fontSize: '15px', color: psiTokens.text.secondary, lineHeight: 1.9, mb: 3 }}>
              With over 20 years of experience leading training and consulting programs in continuous
              improvement, Fidel has collaborated with industrial organizations across multiple sectors and
              countries, helping them not just solve problems, but understand the conditions that caused them.
            </Typography>
            <Typography sx={{ fontSize: '15px', color: psiTokens.text.secondary, lineHeight: 1.9, mb: 4 }}>
              His approach is rooted in asking better questions — powerful questions generate powerful answers.
              PSI develops in its clients the habit of looking beyond the perceived effect of a problem,
              evaluating the entire system: machinery, process design and capacity, operator training, clarity
              of standards, and more.
            </Typography>

            <Stack direction="row" flexWrap="wrap" gap={1.5}>
              {credentials.map((cred) => (
                <Box
                  key={cred}
                  sx={{
                    backgroundColor: '#f3f0f7',
                    border: `1px solid ${psiTokens.primary.light}`,
                    borderRadius: '14px',
                    padding: '6px 14px',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: psiTokens.primary.dark,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {cred}
                </Box>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src="/images/fidel/fidel.jpg"
              alt="Fidel Gutiérrez Sánchez"
              sx={{
                width: '100%',
                aspectRatio: '384 / 400',
                objectFit: 'cover',
                borderRadius: '16px',
                border: `1px solid ${psiTokens.border}`,
                display: 'block',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
